import { FramePopup } from "./FramePopup";
import { IAppComponent } from "./IAppComponent";
import { LanguageString } from "../Model/LanguageString";
import { IAppInitialData, CustomAppValues } from "./IAppInitialData";
import { MsoTable } from "../Controls/Table/MsoTable";
import { Toolbar } from "../Controls/Toolbar";
import { PopupForm } from "./PopupForm";
import { GridViewSelect } from "./GridViewSelect";
import { User } from "./User";
import { MeasureEditFactory } from "../Pages/Measure/MeasureEditFactory";
import { EventDispatcher } from "../Events/EventDispatcher";
import { PopupCloseType, PagePopup } from "../Controls/PagePopup";
import { LockManager } from "../Common/LockManager";
import { AppDragData } from "./AppDragData";
//import { isArray } from "jquery";
import { LeftMenu } from "../Controls/LeftMenu";
import { SearchBox } from "../Common/Search/SearchBox";
import { NewMeasureMenu } from "../Common/NewMeasureMenu";
import { OnlineUserManager } from "../Common/OnlineUserManager";
import { FixedDialog } from "../Controls/FixedDialog";
import { PopupOriginalComponent } from "./PopupOriginalComponent";
import { DynPopup } from "../Components/DynPopup";
import { ICustomerServive } from "./CustomerService/ICustomerService";
import { VetterStrategyCustomerService } from "../Areas/VetterStrategy/CustomerService/VetterStrategyCustomerService";
import { VattenfallCustomerService } from "../Areas/Vattenfall/CustomerService/VattenfallCustomerService";
import { PagLaunchCockpitCustomerService } from "../Areas/PagLaunchCockpit/Models/PagLaunchCockpitCustomerService";
import { IWidgetComponent } from "../Controls/Widgets/Components/IWidgetComponent";
import { Progressbar } from "./Progressbar";
import { IProgressState } from "../Areas/Measures/IProgressState";
import { BmwFFCustomerService } from "../Areas/BmwFF/BmwFFCustomerService";
import { KurarayCustomerService } from "../Areas/Kuraray/CustomerService/KurarayCustomerService";
import * as toastr from "../../lib/toastr/toastr.min";

const _MS_PER_DAY = 1000 * 60 * 60 * 24;
const _PROGRESSBAR_WAIT = 500;

declare const appInitialData: IAppInitialData;

export enum LimitType {
    user, template
}




/**
 * Global methods and data.
 * Created in /Pages/Shared/_LayoutFlex.cshtml.
 */
export class App {
    /** Popup window handler */
    public framePopup: FramePopup;

    /** Current user language with first letter in upper case, e.g. "De" */
    public languageUpperCase: string;

    /** Default language with first letter in upper case, e.g. "De" */
    public defaultLanguageUpperCase: string;

    /** All supported languages */
    public allLanguages: string[];

    /** Available languages */
    public availableLanguages: string[];

    public disablePopup: boolean = false;

    public dragData: AppDragData;

    public createDependecyCategoryContent: boolean;

    public cockpitVerwaltungAktiv: boolean;
    public searchShowId: boolean;

    public customerService: ICustomerServive;

    public static activeWidgets: IWidgetComponent[];

    /** Array of registered components */
    private components: Array<IAppComponent>;
    private rootUrl: string;
    public language: string;
    public defaultLanguage: string;
    public maxTreeViewDisplayLevels: number = 100;
    public useInternalNames: boolean;
    public trafficLightSetting: number;
    public measuresLazyLoadingAmount?: number;
    public useNewUsersInMeasure: boolean;
    public decimalChar: number;

    private popupFormName: string;

    public videoWindowDimensions: string = "width=1024,height=576";
    public useCategoryEmailFunction: boolean;

    public isPagStrategy2030: boolean;
    public isVetterStrategy: boolean;
    public isVattenfall: boolean;
    public isKuraray: boolean;

/** wait panel control **/
    private waitPanel: HTMLElement = null;
    private progressBar: HTMLElement = null;

    public get onNewMeasureCreated() {
        return this._onNewMeasureCreated.asEvent();
    }
    private _onNewMeasureCreated = new EventDispatcher<PopupCloseType, number>();

    public get customApp(): CustomAppValues {
        return appInitialData.customApp;
    }

    private isInitialized: boolean = false;

    /**
     * Constructor.
     * @param rootUrl Absolute root Url.
     * @param language Current user language.
     * @param defaultLanguage Default language.
     */
    constructor(data: IAppInitialData) {
        this.rootUrl = data.rootUrl;
        this.language = data.currentLanguage;
        this.defaultLanguage = data.defaultLanguage;
        this.useNewUsersInMeasure = data.useNewUsersInMeasure === true;
        this.decimalChar = data.decimalChar ? data.decimalChar : 0;

        this.components = [];
        this.languageUpperCase = this.language.charAt(0).toUpperCase() + this.language.slice(1);
        this.defaultLanguageUpperCase = this.defaultLanguage.charAt(0).toUpperCase() + this.defaultLanguage.slice(1);
        this.allLanguages = JSON.parse(data.allLanguagesJson.replace(new RegExp("&quot;", "g"), "\""));
        this.availableLanguages = JSON.parse(data.availableLanguagesJson.replace(new RegExp("&quot;", "g"), "\""));
        this.popupFormName = data.popupFormName;
        this.createDependecyCategoryContent = data.createDependencyCategoryContent;
        this.cockpitVerwaltungAktiv = data.cockpitVerwaltung;
        this.searchShowId = data.searchShowId === false ? false : true;
        this.useInternalNames = data.useInternalNames === true ? true : false;
        this.trafficLightSetting = data.trafficLightSetting;
        this.measuresLazyLoadingAmount = data.measuresLazyLoadingAmount;
        this.useCategoryEmailFunction = data.useCategoryEmailFunction;

        this.isPagStrategy2030 = data.isPagStrategy2030 === true;
        this.isVetterStrategy = data.isVetterStrategy === true;
        this.isVattenfall = data.isVattenfall === true;
        this.isKuraray = data.isKuraray === true;

        if (!App.activeWidgets) App.activeWidgets = [];

        window["app"] = this;
    }

    /**
     * Initialize all components on document ready.
     */
    public initialize() {

        if (this.isInitialized) {
            return;
        }
        this.isInitialized = true;

        (this.onlineUserManager as OnlineUserManager).requestUpdate();

        this.initializeCustomerService();
      
        let searchBox = new SearchBox();
        searchBox.initialize();

        let newMeasureMenu = new NewMeasureMenu();
        newMeasureMenu.initialize();

        // Handbuch
        let helpButton = document.getElementById("frameHelp");
        helpButton?.addEventListener("click", (ev: MouseEvent) => {
            let href:string = "";
            if (this.languageUpperCase == "De")
                href = app.resolveUrl("~/help/MSO_Maestro-5_Handbuch.pdf");
            else
                href = app.resolveUrl("~/help/MSO_Maestro-5_Manual.pdf");
            window.open(href, '_blank', 'width=500, height=600, location=no, status=yes, resizable=yes, scrollbars=yes');
        });

        if (!this.disablePopup) {
            this.framePopup = new FramePopup();
            this.framePopup.initialize();
        }

        if (this.popupFormName) {
            PopupForm.initIFrame(this.popupFormName);
        }

        this.initializeControls();

        for (let comp of this.components) {
            comp.initialize();
        }

        new User().initialize();

        const headerBrandMenu = document.getElementById("frameHeaderBrandMenu");
        if (headerBrandMenu && headerBrandMenu.getAttribute("data-auth") == "true") {
            headerBrandMenu.classList.add("pointer");
            headerBrandMenu.addEventListener("click", (ev: MouseEvent) => {
                const popup = document.getElementById("frameHeaderBrandMenuPopup");
                ev.cancelBubble = true;
                this.framePopup.toggle(popup);
            });
        }

        if ($.fn["jPicker"]) {
            $.fn["jPicker"].defaults.images.clientPath = app.resolveUrl('~/images/Plugins/jPicker/');
        }
    }

    private initializeCustomerService = () => {
        if (this.isVetterStrategy) {
            this.customerService = new VetterStrategyCustomerService();
        }
        else if (this.isVattenfall) {
            this.customerService = new VattenfallCustomerService();
        }
        else if (this.customApp == "PagLaunchCockpit") {
            this.customerService = new PagLaunchCockpitCustomerService();
        }
        else if (this.isKuraray) {
            this.customerService = new KurarayCustomerService();
        }
        else if (this.customApp == "BmwFF") {
            this.customerService = new BmwFFCustomerService();
        }
    }

    /**
     * Create all auto generate controls (MsoTable, Toolbar).
     * Method is called on app.initialize and can also be called after loading additional content via AJAX unobstrusive.
     * */
    public initializeControls() {
        // auto generate MsoTable
        const tables = document.getElementsByClassName("mso-table-autogenerate");
        if (tables) {
            for (let i = 0; i < tables.length; i++) {
                const table = tables.item(i) as HTMLElement;
                if (!table.classList.contains("mso-autogenerate-done")) {
                    table.classList.add("mso-autogenerate-done");
                    const mdl = new MsoTable(table);
                }
            }
        }

        // auto generate Toolbar
        const toolbars = document.getElementsByClassName("mso-toolbar-autocreate");
        if (toolbars) {
            for (let i = 0; i < toolbars.length; i++) {
                const toolbar = toolbars.item(i) as HTMLElement;
                if (!toolbar.classList.contains("mso-autogenerate-done")) {
                    toolbar.classList.add("mso-autogenerate-done");
                    const mdl = new Toolbar(toolbar);
                }
            }
        }

        // auto generate left menus
        LeftMenu.instance = new LeftMenu();
        LeftMenu.instance.initialize();

        // modal poup admin button
        const modalAdminButton = document.getElementById("msoModalButtonAdmin") as HTMLAnchorElement;
        if (modalAdminButton) {
            modalAdminButton.href = this.resolveUrl("~/Admin");
        }

        // modal poup cancel button
        const modalCancelButton = document.getElementById("msoModalButtonCancel");
        if (modalCancelButton) {
            modalCancelButton.addEventListener("click", this.handleCancelClick);
        }

        // modal popup save button
        const modalSaveCloseButton = document.getElementById("msoModalButtonSaveClose");
        if (modalSaveCloseButton) {
            modalSaveCloseButton.addEventListener("click", () => {
                if (this.getParameterByName("jsxPopup") == "1") {
                    // current popup is Controls/Popup.tsx
                    PagePopup.saveAndClose();
                }
                else {
                    PopupForm.activePopup.save();
                }
            });
        }

        // modal popup save button
        const modalSaveButton = document.getElementById("msoModalButtonSave");
        if (modalSaveButton) {
            modalSaveButton.addEventListener("click", () => {
                if (this.getParameterByName("jsxPopup") == "1") {
                    // current popup is Controls/Popup.tsx
                    PagePopup.save();
                }
                else {
                    PopupForm.activePopup.save();
                }
            });
        }

        // modal popup delete button
        const modalDeleteButton = document.getElementById("msoModalButtonDelete");
        if (modalDeleteButton) {
            modalDeleteButton.addEventListener("click", () => {
                if (this.getParameterByName("jsxPopup") == "1") {
                    // current popup is Controls/Popup.tsx
                    PagePopup.delete();
                }
                else {
                    PopupForm.activePopup.delete();
                }
            });
        }

        // grid view edit
        const gridViewEdits = document.getElementsByClassName("grid-view-select-control");
        if (gridViewEdits) {
            for (let i = 0; i < gridViewEdits.length; i++) {
                const edit = gridViewEdits.item(i) as HTMLElement;
                if (!edit.classList.contains("mso-autogenerate-done")) {
                    edit.classList.add("mso-autogenerate-done");
                    const mdl = new GridViewSelect(edit);
                }
            }
        }

        // new measure menu items
        const newMenuItems = document.getElementsByClassName("menu-new-measure-item");
        if (newMenuItems) {
            for (let i = 0; i < newMenuItems.length; i++) {

                const item = newMenuItems.item(i) as HTMLElement;
                if (!item.classList.contains("mso-autogenerate-done")) {
                    item.classList.add("mso-autogenerate-done");
                    item.addEventListener("click", (ev: MouseEvent) => {
                        let element = ev.currentTarget as HTMLElement;
                        const original = (ev.currentTarget as HTMLElement).getAttribute("data-original");
                        let isDoc = (ev.currentTarget as HTMLElement).getAttribute("data-type") == "doc";

                        if (isDoc) {
                            window.open(app.resolveUrl(`~/videos/${(ev.currentTarget as HTMLElement).getAttribute("data-file-name")}`), '_blank', 'width=500, height=600, location=no, status=yes, resizable=yes, scrollbars=yes');
                        }
                        else if (original == "1") {
                            PopupOriginalComponent.create(parseInt((ev.currentTarget as HTMLElement).getAttribute("data-id")), 0);
                        }
                        else {
                            if (element.hasAttribute("data-data-template-id")) {
                                let dataTemplateId = Number(element.getAttribute("data-data-template-id"));
                                let isEditingScenario = element.getAttribute("data-editing-scenario") == "true";
                                this.openNewMeasurePopup(parseInt((ev.currentTarget as HTMLElement).getAttribute("data-id")), dataTemplateId, isEditingScenario);
                            }
                            else {
                                this.openNewMeasurePopup(parseInt((ev.currentTarget as HTMLElement).getAttribute("data-id")));
                            }
                        }
                    });
                }
            }
        }

        // numeric controls generated in TextBoxTagHelper
        const numericTextBoxes = document.getElementsByClassName("textbox-numeric-control");
        if (numericTextBoxes) {
            for (let i = 0; i < numericTextBoxes.length; i++) {
                const item = numericTextBoxes.item(i) as HTMLElement;
                ($(item) as any).inputNumber();
            }
        }
    }

    public getAppInitialDataSetting = (setting: string) => {
        return appInitialData[setting];
    }

    public openNewMeasurePopup(templateId: number, dataTemplateId?: number, isEditingScenario?: boolean) {
        if (this.customApp == "PagQCall") {
            new PagePopup({
                url: "~/PagQCall/EditTopic/0/1",
                resultId: 0,
                showCloseButton: false,
                fullScreen: true,
                onClose: (reason: PopupCloseType, id: number): boolean => {
                    this.dispatchOnNewMeasureCreated(reason, id);
                    return true;
                }
            })
        }
        else if (this.customApp == "PagFastTrack") {
            new PagePopup({
                url: "~/PagFastTrack/EditTopic/0/1",
                resultId: 0,
                showCloseButton: false,
                fullScreen: true,
                onClose: (reason: PopupCloseType, id: number): boolean => {
                    this.dispatchOnNewMeasureCreated(reason, id);
                    return true;
                }
            })
        }
        else if (this.customerService && this.customerService.onNewMeasureMenuItem) {
            this.customerService.onNewMeasureMenuItem(templateId);
        }
        else {
            let additionalActions = "";
            additionalActions += (dataTemplateId && !isNaN(dataTemplateId) ? `setDataTemplateId:${dataTemplateId}` : "");
            if (additionalActions.indexOf("setDataTemplateId") > -1) {
                additionalActions += isEditingScenario ? ";setEditingScenario:true" : "";
            }


            MeasureEditFactory.showMeasure({
                measureId: 0,
                templateId: templateId,
                parentId: 0,
                parentGuid: "null",
                fullScreen: true,
                additionalAction: (additionalActions.length ? additionalActions : undefined),
                onClose: ((reason: PopupCloseType, id: number) => {
                    this.dispatchOnNewMeasureCreated(reason, id);
                })
            });
        }
    }

    public dispatchOnNewMeasureCreated(reason: PopupCloseType, id: number): void {
        this._onNewMeasureCreated.dispatch(reason, id);

        if (id != 0) {
            for (let widget of App.activeWidgets) {
                if (widget.addNewMeasure) {
                    widget.addNewMeasure(id);
                }
            }
        }
    }

    /**
     * add event handlers to this array to execute them on the cancel button, BEFORE the active popup is closed.
     */
    cancelEvents: { (event: Event): void }[] = [];
    private handleCancelClick = (event: Event) => {
        // Unfortunately, event handlers added to the cancel button won't necessarily execute befor the active popup is cosed.
        // This way makes sure that events added to the cancelEvents array are executed before the active popup is closed.
        if (this.cancelEvents && this.cancelEvents.length > 0) {
            for (let ev of this.cancelEvents) {
                ev(event);
            }
        }

        if (this.getParameterByName("jsxPopup") == "1") {
            // current popup is Controls/Popup.tsx
            PagePopup.cancel();
        }
        else {
            if (PopupForm.activePopup) {
                PopupForm.activePopup.cancel();
            }
        }
    }

    /**
     * Add a component to the app and initialize it on page load.
     * @param comp The component, must implement IAppComponent.
     */
    public addComponent(comp: IAppComponent): void {
        this.components.push(comp);
    }

    /**
     * Get absolute Url to relative Url.
     * @param url relative url, format: ~/...
     */
    public resolveUrl(url: string): string {
        return url.replace('~/', this.rootUrl);
    }

    /**
     * Get the value of a query parameter, e.g. "?foo=12", getParameterByName("foo") will return "12".
     * @param name Name of the query parameter.
     */
    public getParameterByName(name: string): string {
        const match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
        return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
    }

    public cleanIndexUrl(): void {
        if (window.location.search.length !== 0 && window.location.pathname.toLowerCase().includes('/index')) {
            window.location.search = '';
        }
    }

    /**
     * Convert a value to number.
     * @param value The value to convert.
     * @param defaultValue Optional default value.
     */
    public anyToFloat = (value: any, defaultValue: number = null, decimalSeparator: number = null): number => {
        if (value == null || value === undefined) {
            return defaultValue;
        }
        else if (typeof value === "string") {
            if (value.length > 0) {
                value = this.sanitizeDecimal(value, decimalSeparator);
                value = this.setDecimalToPointSeparator(value, decimalSeparator);
                return parseFloat(value.replace(new RegExp("\\,", "g"), "."));
            }
            return null;
        }
        else if (typeof value === "number") {
            return value;
        }
        else {
            throw new Error("App.anyToFloat: invalid format of value!");
        }
    }

    /**
     * Takes a decimal as a string in the format xxxxx.xxx and checks if the number of decimal places exceeds th given number.
     * This function available to use in input event handlers to restrict entering more that the given number of decimal places. 
     * The decimal has to be sanitized beforehand.
     * @param sanitizedDecimal
     * @param decimalPlaces
     */
    public exceedsDecimalPlaces = (sanitizedDecimal: string, decimalPlaces: number, cursorPosition: number) => {
        let usedSeparator: string;
        if (sanitizedDecimal.includes(",")) {
            usedSeparator = ",";
        } else if (sanitizedDecimal.includes(".")) {
            usedSeparator = ".";
        } else {
            return false;
        }

        let parts = sanitizedDecimal.split(usedSeparator);
        if (parts.length > 1 && parts.length < 3) {
            // Add +1 to make it possible to write directly before the separator.
            if (cursorPosition < parts[0].length + 1 || parts[1].length < decimalPlaces) {
                return false;
            }
        } else {
            console.log(`Decimalinput is in the wrong format: ${sanitizedDecimal}.`);
            // return false, so the input field can be edited to correct the value.
            return false;
        }
        return true;
    }

    /**
     * Removes thousands seperators from a decimal string according to the selected decimal point character.
     * @param decimal
     * @param decimalSeperator
     */
    public sanitizeDecimal = (decimal: string, decimalSeperator: number = null): string => {
        let decimalSeperatorChar = this.getDecimalSeparator(decimalSeperator);

        // Strip all non.digit characters (should leave .,-)
        decimal = decimal.replace(/[^\d.,-]/g, '');

        // Only leave the seperatorChar (in case there are thousands-seperators present).
        if (decimalSeperatorChar === ",") {
            // Remove all dots from the value.
            decimal = decimal.replace(new RegExp("\\.", "g"), "");
        } else {
            // Remove all commas from the value.
            decimal = decimal.replace(new RegExp("\\,", "g"), "");
        }
        return decimal;
    }

    /**
     * Sets the decimalString of user input to a format that can be parsed to a number;
     * @param sanitizedDecimal
     * @param decimalSeparatorInt
     */
    setDecimalToPointSeparator = (sanitizedDecimal: string, decimalSeparatorInt: number) => {
        let decimalSperatorChar = this.getDecimalSeparator(decimalSeparatorInt);
        sanitizedDecimal = sanitizedDecimal.replace(decimalSperatorChar, ".");
        return sanitizedDecimal;
    }

    /**
     * Formats a decimal given as a string with appropriate decimal point and thousands seperators.
     * @param decimal
     * @param decimalSeperator
     */
    public formatDecimalString = (decimal: string, decimalSeperator: number = null, decimalPlaces: number = null, displayWithoutThousands: boolean = false): string => {
        if (decimal && decimal.length > 0) {
            decimal = this.sanitizeDecimal(decimal, decimalSeperator);
            decimal = this.setDecimalToPointSeparator(decimal, decimalSeperator);
            let decimalFloat = parseFloat(decimal);
            if (!isNaN(decimalFloat)) {
                return this.formatDecimalNumber(decimalFloat, decimalSeperator, decimalPlaces, displayWithoutThousands);
                let decimalSeperatorChar = this.getDecimalSeparator(decimalSeperator);
                if (decimalSeperatorChar === ',') {
                    return decimalFloat.toLocaleString("de", { maximumFractionDigits: decimalPlaces, minimumFractionDigits: decimalPlaces });
                }
                else {
                    return decimalFloat.toLocaleString("en", { maximumFractionDigits: decimalPlaces, minimumFractionDigits: decimalPlaces });
                }
                //return this.formatDecimalNumber(decimalFloat, decimalSeperator, decimalPlaces);
            } else {
                return "";
            }
        } else {
            return "";
        }
    }

    /**
     * Formats a given number with an appropriate decimal point and thousands seperators.
     * @param decimal
     * @param decimalSeperator
     */
    public formatDecimalNumber = (decimal: number, decimalSeperator: number = null, decimalPlaces: number = null, displayWithoutThousands: boolean = false): string => {
        if (app.isNullOrUndefined(decimal)) {
            return "";
        }
        else {
            let decimalSeperatorChar = this.getDecimalSeparator(decimalSeperator);
            let returnValue = "";
            if (decimalSeperatorChar === ',') {
                returnValue = decimal.toLocaleString("de", { maximumFractionDigits: decimalPlaces, minimumFractionDigits: decimalPlaces });
                if (displayWithoutThousands) {
                    returnValue = returnValue.replace('.', '');
                }
            }
            else {
                returnValue = decimal.toLocaleString("en", { maximumFractionDigits: decimalPlaces, minimumFractionDigits: decimalPlaces });
                if (displayWithoutThousands) {
                    returnValue = returnValue.replace(',', '');
                }
            }

            return returnValue;
        }
    }

    /**
     * Returns the decimal seperator as string from the values 0 or 1 which are trasmitted by the server.
     * @param decimalSeperatorInt
     */
    public getDecimalSeparator = (decimalSeperatorInt: number = null): string => {
        // Determine used seperator from the int from the server.
        let decimalSeperatorChar: string;
        if (!decimalSeperatorInt || decimalSeperatorInt == 0) {
            decimalSeperatorChar = ",";
        } else {
            decimalSeperatorChar = ".";
        }
        return decimalSeperatorChar;
    }

    /**
     * Inserts a string into the value at the selected startIndex and returns the result.
     * @param value
     * @param startIndex
     * @param add
     */
    public stringInsertAt = (value: string, startIndex: number, add: string = undefined) => {
        startIndex = startIndex > 0 ? startIndex : 0;
        let newVal = value.substring(0, startIndex) + (add ?? "") + value.substring(startIndex, value.length);
        return newVal;
    }

    /**
     * Convert a value to integer.
     * @param value The value to convert.
     * @param defaultValue Optional default value.
     */
    public anyToInt(value: any, defaultValue: number = null): number {
        if (value == null || value === undefined) {
            return defaultValue;
        }
        else if (typeof value === "boolean") {
            if (value === true) {
                return 1;
            } else if (value === false) {
                return 0;
            } else {
                return defaultValue;
            }
        }
        else if (typeof value === "string") {
            if (value.length > 0) {
                return parseInt(value);
            }
            return defaultValue;
        }
        else if (typeof value === "number") {
            return value;
        }
        else {
            throw new Error("App.anyToInt: invalid format of value!");
        }
    }

    /**
     * Convert a value to Date. Value can be Date or string (UTC and german).
     * @param value The value to convert.
     */
    public anyToDate(value: any): Date {
        if (value == null || value === undefined) {
            return null;
        }
        else if (typeof value.getMonth === "function") {
            return (value as Date);
        }
        else if (typeof value === "string") {
            let text: string = value;
            if (text.length > 5) {
                // UTC (yyyy-mm-ddT)
                if (text[4] == "-") {
                    let date = new Date(text);
                    return date;
                }
                else {
                    // assume german format: dd.mm.yyyy
                    let parts = text.split(".");
                    if (parts.length >= 3) {
                        let date = new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]));
                        return date;
                    }
                }
            }
        }
        return null;
    }

    /**
     * Clones a date into a new date object.
     * @param from
     */
    public dateCopy = (from: Date): Date => {
        let internalDate: Date;

        if (from) {
            if (!(from instanceof Date)) {
                console.log("dateCopy was called on something other than a date: " + from);
                try {
                    // try to parse to a date
                    internalDate = new Date(from);
                } catch (err) {
                    console.log(err);
                }

            } else {
                internalDate = from;
            }
        } else {
            console.log(`dateCopy: from is '${from}'.`);
        }

        if (internalDate) {
            let returnDate = new Date();
            returnDate.setFullYear(internalDate.getFullYear(), internalDate.getMonth(), internalDate.getDate());
            return returnDate;
        }
        return undefined;
    }

    destroyDomElements(element: HTMLElement) {
        let parent = element.parentElement;
        this.destroyDomChildren(element);
        if (parent) {
            parent.removeChild(element);
        }
    }

    destroyDomChildren(element: HTMLElement) {
        while (element.firstChild) {
            element.removeChild(element.lastChild);
        }
    }

    isVisible(element: HTMLElement) {
        var style = window.getComputedStyle(element);
        return style.display != "none";
    }

    areEqualShallow(a, b) {
        // TODO move to app class
        for (var key in a) {
            if (!Array.isArray(a[key]) && (!(key in b) || a[key] !== b[key])) {
                return false;
            }
        }
        for (var key in b) {
            if (!Array.isArray(b[key]) && (!(key in a) || a[key] !== b[key])) {
                return false;
            }
        }
        return true;
    }

    /**
     * This clears any array while preserving its references.
     * @param arr
     */
    clearArray(arr: any[]) {
        arr.splice(0, arr.length);
    }

    /**
     * Pass this function to an Array.filter call, to get a collection of unique items.
     * Analog to Linq Distinct. Usage: someArray.filter(app.onlyUnique);
     * 
     * @param value
     * @param index
     * @param self
     */
    onlyUnique = (value, index, self) => {
        return self.indexOf(value) === index;
    }

    sortBy(a: any, b: any, property: string) {
        if (a[property] > b[property]) return 1;
        else if (a[property] == b[property]) return 0;
        else return -1;
    }

    sortByName(a: string, b: string) {
        if (a > b) return 1;
        else if (a == b) return 0;
        else return -1;
    }

    sortByRecursive(collection: any[], property: string, childrenProperty: string) {
        for (let item of collection) {
            if (item[childrenProperty] && Array.isArray(item[childrenProperty])) {
                this.sortByRecursive(item[childrenProperty], property, childrenProperty);
            }
        }
        collection.sort((a, b) => this.sortBy(a, b, property));
    }

    //delay(callback, ms: number) {
    //    let timer: number = 0;
    //    return function () {
    //        let context = this, args = arguments;
    //        clearTimeout(timer);
    //        timer = setTimeout(function () {
    //            callback.apply(context, args);
    //        }, ms || 0);
    //    };
    //}

    /**
     * Returns a localized date string of the given value.
     * @param value Date value, can be Date object or string.
     */
    public getDateString(value: any, withTime: boolean = false): string {
        let date = this.anyToDate(value);
        if (date) {
            if (withTime) {
                return this.zeroPad(date.getDate(), 2) + "." + this.zeroPad(date.getMonth() + 1, 2) + "." + this.zeroPad(date.getFullYear(), 4) +
                    " " + this.zeroPad(date.getHours(), 2) + ":" + this.zeroPad(date.getMinutes(), 2);
            }
            else {
                return this.zeroPad(date.getDate(), 2) + "." + this.zeroPad(date.getMonth() + 1, 2) + "." + this.zeroPad(date.getFullYear(), 4);
            }
        }
        return "";
    }

    // https://stackoverflow.com/questions/2998784/how-to-output-integers-with-leading-zeros-in-javascript
    private zeroPad(num: number, places: number): string {
        var zero = places - num.toString().length + 1;
        return Array(+(zero > 0 && zero)).join("0") + num;
    }

    /**
     * Send the new language to the server and reload page.
     * @param culture New language, e.g. "de".
     */
    public setLanguage(culture: string): void {
        $.ajax({
            type: "PUT",
            url: this.resolveUrl("~/api/language/" + culture),
            success: function (result) {
                location.reload();
            }
        });
    }

    /**
     * Add number of days to the date.
     * @param date The Date object.
     * @param days Number of days to add.
     * @returns A new Date object.
     */
    public addDays(date: Date, days: number): Date {
        var result = new Date(date.valueOf());
        result.setDate(result.getDate() + days);
        return result;
    }

    /**
     * Calculates the difference between two dates in days.
     * @param a First date.
     * @param b Second Date.
     * @returns Number of days between a and b.
     */
    public dateDiffInDays(a: Date, b: Date): number {
        // Discard the time and time-zone information.
        const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
        const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

        return Math.floor((utc2 - utc1) / _MS_PER_DAY);
    }

    /**
     * Toggle full screen mode.
     */
    public toggleFullScreen() {
        let frame = document.getElementById("frameContainer");
        frame.classList.toggle("full-screen-container");
    }

    /**
     * Create a unique guid
     */
    public createGuid(): string {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    public createRadomizedLetters(length: number): string {
        var result = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }

    /**
     * This helper function is needed, because parseInt does not always 
     * return NaN when a guid starting with numbers is parsed.
     * @param x
     */
    public intOrNaN(x) {
        return /^\d+$/.test(x) ? +x : NaN
    }

    /**
     * Add an error message to validation div.
     * @param msg Error message to show.
     * @param validationDivId Optional id of validation div to use.
     */
    public addError(msg: string, validationDivId: string = null) {

        // Check if the error message is a html page. If yes, only show a toastr message.
        if (msg && !msg.startsWith("<")) {

            let validationDiv: HTMLElement = null;
            if (validationDivId) {
                validationDiv = document.getElementById(validationDivId);
            }
            else {
                let search = document.getElementsByClassName("validation-summary-valid");
                if (search.length > 0) {
                    validationDiv = search.item(0) as HTMLElement;
                    validationDiv.classList.remove("validation-summary-valid");
                    validationDiv.classList.add("validation-summary-errors");
                }
                else {
                    search = document.getElementsByClassName("validation-summary-errors");
                    if (search.length > 0) {
                        validationDiv = search.item(0) as HTMLElement;
                    }
                }
            }
            if (validationDiv) {
                if (validationDiv.classList.contains("validation-summary-valid")) {
                    validationDiv.classList.remove("validation-summary-valid");
                    validationDiv.classList.add("validation-summary-errors");
                }
                let ul = validationDiv.firstElementChild;
                if (!ul) {
                    ul = document.createElement("ul");
                    validationDiv.appendChild(ul);
                }
                let li = document.createElement("li");
                li.innerText = msg;
                ul.appendChild(li);
            }
            else {
                alert(msg);
            }
        }

        toastr.options["positionClass"] = "toast-top-full-width";
        toastr["error"](Resources.Common.saveError);

    }

    getNameInLanguage(field: LanguageString): string {
        if (field.inLanguage) {
            return field.inLanguage;
        }
        else {
            // if "field" was deserialized without applying of Object.assign(), it will not have the property "inLanguage"
            let result: string = field["value" + this.languageUpperCase];
            if (!result) {
                result = field["value" + this.defaultLanguageUpperCase];
            }
            if (!result) {
                for (let lang of this.availableLanguages) {
                    result = field["value" + lang.charAt(0).toUpperCase() + lang.slice(1)];
                    if (result) {
                        break;
                    }
                }
            }
            return result;
        }
    }

    capitalizeLanguageString(languageString: string): string {
        return languageString.charAt(0).toUpperCase() + languageString.slice(1);
    }

    _lockManager: LockManager;
    get lockManager(): LockManager {
        if (!this._lockManager) {
            this._lockManager = new LockManager();
        }
        return this._lockManager;
    }

    _onlineUserManager: OnlineUserManager;
    get onlineUserManager(): OnlineUserManager {
        if (!this._onlineUserManager) {
            this._onlineUserManager = new OnlineUserManager();
        }
        return this._onlineUserManager;
    }

    public showPopup(url: string, id: number, fullscreen: boolean = true, tableId?: string) {
        const popup = new PagePopup({
            url: url,
            fullScreen: fullscreen,
            resultId: id,
            onClose: (reason: PopupCloseType, newId: number): boolean => {
                if (tableId) {
                    const table = MsoTable.getTableById(tableId);
                    if (table) {
                        if (reason == "delete") {
                            table.removeRow(newId.toString());
                        }
                        else if (reason == "save") {
                            if (newId != id) {
                                table.addRow(newId.toString());
                            }
                            else {
                                table.updateRow(newId.toString());
                            }
                        }
                    }
                }
                return true;
            },
            onLoaded: () => {

                let entityType = document.querySelector("[entity-type]")?.getAttribute('entity-type');
                if (entityType) {
                    let entityLockable: boolean = (app.lockManager as LockManager).getLockableInfo(entityType);

                    // check if the list is of lockable entities.. if yes:
                    if (entityLockable == true) {
                        // Tell the list that it is for lockable objects.
                        let tableElement = document.querySelector("[entity-type]")
                        if (tableElement) {
                            tableElement.setAttribute("entity-lockable", "true");
                        }

                        let iFrame = top.frames["testIframe"];

                        // lock the opened object
                        let jsonModelElement = iFrame.contentDocument.getElementById("jsonModel") as HTMLInputElement;
                        let modelIdElement = iFrame.contentDocument.getElementById("Model_Id") as HTMLInputElement;
                        

                        if (jsonModelElement) {
                            let parsedObject = JSON.parse(jsonModelElement.value);
                            if (parsedObject) {
                                console.log(`Entity type: ${entityType} ID: ${parsedObject.id} --- Lockable? ${entityLockable}`);
                                (app.lockManager as LockManager).requestLock(parsedObject.id, entityType, iFrame.contentWindow);
                            }
                        } else if (modelIdElement) {
                            let id = Number(modelIdElement.value);
                            if (!isNaN(id)) {
                                (app.lockManager as LockManager).requestLock(id, entityType, iFrame.contentWindow);
                            }
                        }
                    }
                }
            }
        });
    }

    // Display message when users/templates limit, precise by the license Key, are reached 
    public onNewItemClick(type: number) {
        let message: string;
        if (type == LimitType.user)
            message = Resources.LicenseKeySetting.maxLimitReached.replace("{type}", Resources.Common.users);
        else
            message = Resources.LicenseKeySetting.maxLimitReached.replace("{type}", Resources.Common.templateEvents);
        new FixedDialog()
            .showOk(message);
    }

    public OnImportClick(importUrl: string) {
        $.ajax({
            url: app.resolveUrl(importUrl.format()),
            type: "POST",
            contentType: "application/json",
            success: (result) => {
                if (result.success) {
                    location.reload();
                }
                console.log(result);
            },
            error: (err) => {
                console.log(err);
                alert(err);
            },
        });
    }

    public isNullOrUndefined(value: any): boolean {
        return value == null || value === undefined;
    }

    // see https://stackoverflow.com/questions/11832914/round-to-at-most-2-decimal-places-only-if-necessary?page=1&tab=votes#tab-top
    public round(value: number, places: number): number {
        if (this.isNullOrUndefined(value)) {
            return null;
        }
        return +(Math.round(parseFloat(value + "e+" + places)) + "e-" + places);
    }

    public showWaitPanel(): void {
        this.hideWaitPanel();

        this.waitPanel = document.createElement("div");
        this.waitPanel.className = "app-wait-panel fa-5x";
        let icon = document.createElement("i");
        icon.className = "fas fa-circle-notch fa-spin";
        this.waitPanel.appendChild(icon);
        document.body.appendChild(this.waitPanel);
    }

    public showWaitPanelWithInfo(infoUrl: string): void {
        this.hideWaitPanel();

        this.waitPanel = document.createElement("div");
        this.waitPanel.className = "app-wait-panel fa-5x";
        let icon = document.createElement("i");
        icon.className = "fas fa-circle-notch fa-spin";
        this.waitPanel.appendChild(icon);

        document.body.appendChild(this.waitPanel);

        setTimeout(() => { this.waitPanelPollServer(infoUrl) }, _PROGRESSBAR_WAIT);
    }

    waitPanelPollServer = (infoUrl: string): void => {
        $.get(app.resolveUrl(infoUrl), (result: IProgressState) => {
            if (result) {
                if (this.progressBar) {
                    this.progressBar = Progressbar.update(this.progressBar, result.current, result.total, result.info);
                }
                else {
                    this.progressBar = Progressbar.render(result.current, result.total, result.info);
                    if (this.progressBar) {
                        this.waitPanel.appendChild(this.progressBar);
                    }
                }
            }

            setTimeout(() => { this.waitPanelPollServer(infoUrl) }, _PROGRESSBAR_WAIT);
        }).fail(() => {
            this.hideWaitPanel();
        });
    }

    public hideWaitPanel(): void {
        if (this.waitPanel) {
            this.waitPanel.parentElement.removeChild(this.waitPanel);
            this.waitPanel = null;
        }
    }

    public showDialog = (text: string) => {
        DynPopup.ShowDialog(text);
    }

    //**Parse json string and force lower case first letter*/
    public parseJson = (json: string): any => {
        let parsedObject = JSON.parse(json);
        if (parsedObject) {
            return this.convertParsedObject(parsedObject);
        }
        return null;
    }

    //**Force lower case first letter on parsed object*/
    private convertParsedObject = (parsedObject: any): any => {
        if (parsedObject) {
            return Object.keys(parsedObject).reduce((item, index) => {
                if (parsedObject[index] && typeof (parsedObject[index]) == 'object' && !Array.isArray(parsedObject[index]) && Object.keys(parsedObject[index]) && Object.keys(parsedObject[index]).length > 0) {
                    item[this.firstLetterToLowerCase(index)] = this.convertParsedObject(parsedObject[index]);
                }
                else {
                    item[this.firstLetterToLowerCase(index)] = parsedObject[index];
                }
                return item;
            }, {});
        }
        return null;
    }

    //**Convert first letter to lower case*/
    private firstLetterToLowerCase = (name: string): string => {
        if (name && name.length > 0) {
            name = name[0].toLowerCase() + name.slice(1, name.length);
        }

        return name;
    }
}

/** Global application class. */
export const app: App = new App(appInitialData);
window["app"] = app;

/** Initialize class on document ready. */
$(document).ready(function () {
    app.initialize();
});